import http from "./http";

export const getDemoUserPhones = async () => {
  const res = await http.get("get-demo-user-phones");
  return res.data;
};